import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
/*import 'hammerjs';
import 'mousetrap';
import { GalleryModule } from '@ks89/angular-modal-gallery';*/
const DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    suppressScrollX: true
};
const ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG;
export class SharedModule {
}
export { ɵ0 };
